module.exports = __webpack_public_path__ + "static/media/motiv1@2x.47dbc60e.png";